import { createFileRoute, Navigate, useLocation } from '@tanstack/react-router';
import { useMediaQuery, useTheme } from '@mui/material';

function UserProfileIndex() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
  const location = useLocation();

  // On desktop, redirect to account page
  if (isDesktop) {
    return <Navigate to="/user-profile/account" search={location.search} />;
  }

  // On mobile, the layout shows the navigation menu (handled by parent route)
  return null;
}

export const Route = createFileRoute('/user-profile/')({
  component: UserProfileIndex,
});
